export const getIsWholeMonthDisabled = (
  disabled?: Date[],
  monthToCheck?: Date,
) => {
  if (!disabled || disabled.length === 0 || !monthToCheck) {
    return false;
  }

  const year = monthToCheck.getFullYear();
  const month = monthToCheck.getMonth();

  const disabledSet = new Set(
    disabled.map((d) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(),
    ),
  );

  const daysInMonth = new Date(year, month + 1, 0).getDate();

  for (let day = 1; day <= daysInMonth; day++) {
    const current = new Date(year, month, day).getTime();

    if (!disabledSet.has(current)) {
      return false;
    }
  }

  return true;
};
